import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useMsal } from "@azure/msal-react";
import RiskDialogBox from "../RiskDialogBox";
import ViewAllAlerts from "../ViewAllAlerts";
import AlertService from "../../../services/console_services/Alerts";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { renderMetrics } from "./renderMetrics";
import { setPastDueSTOCheck, setShowAlertGraph } from "../../../store/Actions";
import CachedIcon from "@mui/icons-material/Cached";
import AlertGraphPopUp from "./AlertGraphPopUp";

const useStyles = makeStyles((theme) => ({
  card: {
    height: "auto",
    borderRadius: 8,
    background: "#FFF",
    boxShadow:
      "0px 1px 2px rgba(0, 0, 0, 0.05), 0px 2px 16px rgba(0, 0, 0, 0.10)",
    padding: "10px",
    border: "none",
    [theme.breakpoints.down("sm")]: {
      padding: "5px",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  alert: {
    margin: 0,
    padding: theme.spacing(1),
    fontSize: 16,
    fontWeight: 600,
    color: "#333",
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },
  alertCount: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: "#DCE0EA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 10,
    fontWeight: 600,
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      width: 16,
      height: 16,
      fontSize: 8,
      marginLeft: 5,
    },
  },
  viewAllButton: {
    fontSize: "13px !important",
    color: "#333 !important",
    fontWeight: 500,
    fontFamily: "Poppins, sans-serif",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px !important",
    },
  },
  cardContent: {
    padding: "0 10px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 5px",
    },
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "90vh",
  },
}));

const AlertDialogBox = ({
  handleViewAll,
  viewAll,
  _viewAllAlertData,
  handleViewPowerBi,
}) => {
  const classes = useStyles();
  const {
    Network,
    DC,
    Products,
    Customers,
    PL3,
    Division,
    Temperature,
    facType,
    location,
    facId,
    fromState,
    toState,
    fromZip,
    CL6,
    toZip,
    lane,
  } = useSelector((state) => state?.filter);
  const { tabName } = useSelector((state) => state?.tabs);
  const store = useSelector((state) => state);
  const [alertsData, setAlertsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  const selectedScenarios = useSelector(
    (state) => state?.filter?.selectedScenarios,
  );
  const recomFlag = useSelector((state) => state?.filter?.recomFlag);
  const entireState = useSelector((state) => state);
  const showAlertGraph = useSelector((state) => state?.filter?.showAlertGraph);
  const [seletedAlertData, setSelectedAlertData] = useState({});

  const { instance } = useMsal();
  let module;
  const dispatch = useDispatch();

  if (tabName === "Deployment Optimization") {
    module = "DO";
  } else if (tabName === "Deployment Planning") {
    module = "DP";
  } else if (tabName === "FG Salvage") {
    module = "FGS";
  } else if (tabName === "Capacity Planning" || tabName === "CP") {
    module = "CP";
  } else if (tabName === "Distribution_Planning") {
    module = "DIP";
  } else if (tabName === "Potential Out Of Stock") {
    module = "POOS";
  } else if (tabName === "RR") {
    module = "RR";
  } else if (tabName === "Network Planning Simulation") {
    module = "NPS";
  } else {
    module = tabName;
  }

  let storeCheck = store?.filter?.pastDueCheck;
  const getViewAllAlertPast_DueData = async () => {
    setLoading(true);
    let params = {
      module,
      filter: {
        RecommendedDC: DC,
        Network,
        PL3,
        Division,
        MaterialID: Products,
        SoldToName: Customers,
      },
    };

    if (storeCheck) {
      if (storeCheck.tab === "Past Due STOs") {
        params.filter = {
          ...params.filter,
          selectedOption:
            storeCheck?.selectedOption?.X_Axis === "SKU"
              ? "MaterialID"
              : storeCheck?.selectedOption?.X_Axis,
          PastDueFlag: true,
          selectedValue: storeCheck?.selectedOption?.Metric_name,
        };
      } else if (storeCheck.tab === "STRs To Cancel") {
        params.filter = {
          ...params.filter,
          selectedOption:
            storeCheck?.selectedOption?.X_Axis === "SKU"
              ? "MaterialID"
              : storeCheck?.selectedOption?.X_Axis,
          STRs_to_cancel: true,
          selectedValue: storeCheck?.selectedOption?.Metric_name,
        };
      } else if (storeCheck.tab === "STRs Required") {
        if (storeCheck?.selectedOption?.X_Axis) {
          params.filter = {
            ...params.filter,
            selectedOption:
              storeCheck?.selectedOption?.X_Axis === "SKU"
                ? "MaterialID"
                : storeCheck?.selectedOption?.X_Axis,
            STR_reasons: true,
            selectedValue: storeCheck?.selectedOption?.Metric_name,
          };
        } else {
          params.filter = {
            ...params.filter,
            selectedOption: storeCheck?.selectedOption,
            STR_reasons: true,
            selectedValue: storeCheck?.selectedOption,
          };
        }
      } else if (
        storeCheck.tab === "ST Utilization" ||
        storeCheck.tab === "LT Utilization"
      ) {
        if (storeCheck?.selectedOption?.X_Axis) {
          params.filter = {
            ...params.filter,
            Network:
              storeCheck?.selectedOption?.X_Axis === "Network"
                ? [storeCheck?.selectedOption?.Metric_name]
                : [],
            RecommendedDC:
              storeCheck?.selectedOption?.X_Axis === "DC"
                ? [storeCheck?.selectedOption?.Metric_name]
                : [],
            //selectedOption: storeCheck?.selectedOption?.X_Axis,
            //STR_reasons: true,
            //selectedValue: storeCheck?.selectedOption?.Metric_name,
          };
        }
      } else if (storeCheck.tab === "IncidentRateTrend") {
        params.filter = {
          ...params.filter,
          ...(storeCheck?.selectedOption?.X_Axis === "Weekly"
            ? { yearWeek: storeCheck?.selectedOption?.Year_week }
            : {}),
          ...(storeCheck?.selectedOption?.X_Axis === "Monthly"
            ? { yearMonth: storeCheck?.selectedOption?.Year_week }
            : {}),
        };
      } else if (storeCheck.tab === "DetentionSpendTrend") {
        params.filter = {
          ...params.filter,
          ...(storeCheck?.selectedOption?.X_Axis === "Weekly"
            ? { yearWeek: storeCheck?.selectedOption?.year_week_cy }
            : {}),
          ...(storeCheck?.selectedOption?.X_Axis === "Monthly"
            ? { yearMonth: storeCheck?.selectedOption?.year_week_cy }
            : {}),
        };
      } else if (storeCheck.tab === "FacilityTypeLocationShare") {
        params.filter = {
          ...params.filter,
          facility: storeCheck?.selectedOption?.Facility,
        };
      }
    }

    try {
      if (storeCheck?.tab) {
        const data = await AlertService.getAllAlertsAtViewAll(params, instance);
        if (data?.data) {
          setAlertsData(data.data);
          const apiData = {
            selectedOption: {},
            PastDueFlag: false,
          };
          dispatch(setPastDueSTOCheck(apiData));
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false); // Ensure loading state is set to false regardless of success or error
    }
  };

  const getViewAllAlertData = async () => {
    setLoading(true);

    let params = {
      module: module === "Network Planning Simulation" ? "NPS" : module,
      filter: {
        RecommendedDC: DC,
        Network,
        PL3,
        Division,
        CL6,
        MaterialID: Products,
        SoldToName: Customers,
        ScenarioName:
          entireState?.filter?.scenarioValue === ""
            ? []
            : [entireState?.filter?.scenarioValue],
      },
    };

    if (module === "DO" || module === "DP") {
      params.filter = {
        RecommendedDC: DC,
        Network,
        PL3,
        Division,
        MaterialID: Products,
      };
    } else if (module === "POOS") {
      params.filter.ActiveFlag = activeFlagValue;
    } else if (module === "RR") {
      params.acceptCondition = recomFlag;
      params.scenarioCondition = selectedScenarios?.map((item) => item?.value);
    } else if (module === "FF") {
      params.filter = {
        Network,
        temperature: Temperature,
        Source_State: fromState,
        Destination_State: toState,
        Source_3zip: fromZip,
        Destination_3zip: toZip,
        lane: lane,
      };
    } else if (module === "DETENTION") {
      params.filter = {
        Network,
        temperature: Temperature,
        Facility: facId,
        FacilityType: facType,
        Spend_Location_Type: location,
        Source_State: fromState,
        Destination_State: toState,
        Source_3zip: fromZip,
        Destination_3zip: toZip,
        lane: lane,
      };
    } else {
      if (Network) {
        params.filter.Network = Network;
      }
      if (DC) {
        params.filter.RecommendedDC = DC;
      }
    }
    try {
      const data = await AlertService.getAllAlertsAtViewAll(params, instance);
      if (data?.data) {
        setAlertsData(data.data);
        const apiData = {
          selectedOption: {},
          PastDueFlag: false,
        };
        dispatch(setPastDueSTOCheck(apiData));
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getViewAllAlertData();
  }, [
    tabName,
    Network,
    DC,
    Products,
    Customers,
    Division,
    PL3,
    activeFlagValue,
    Temperature,
    facType,
    location,
    facId,
    fromState,
    toState,
    fromZip,
    toZip,
    lane,
    recomFlag,
    selectedScenarios,
    entireState?.filter?.scenarioValue,
    CL6,
  ]);

  useEffect(() => {
    if (storeCheck?.PastDueFlag) {
      getViewAllAlertPast_DueData();
    }
  }, [storeCheck?.selectedOption]);

  const handleAlertMetricClick = (alert) => {
    setSelectedAlertData(alert);
    dispatch(setShowAlertGraph(true));
  };

  const handleCloseAlertGraph = () => {
    dispatch(setShowAlertGraph(false));
  };

  return (
    <>
      <Card className={classes.card}>
        {loading ? (
          <div className={classes.loaderContainer}>
            <Loading />
          </div>
        ) : (
          <>
            <div className={classes.header}>
              <Typography
                className={classes.alert}
                id="customized-dialog-title"
              >
                {module === "RR"
                  ? "Action Items"
                  : module === "IF"
                    ? "Insights"
                    : "Alerts"}
                <span className={classes.alertCount}>
                  {
                    alertsData?.filter((alert) => alert?.Review_Flag === 0)
                      ?.length
                  }
                </span>
                <IconButton
                  aria-label="refresh"
                  onClick={getViewAllAlertData}
                  style={{ marginLeft: 8 }}
                >
                  <CachedIcon style={{ color: "blue" }} />
                </IconButton>
              </Typography>
              <IconButton
                aria-label="view all"
                onClick={handleViewAll}
                className={classes.viewAllButton}
              >
                View All
              </IconButton>
            </div>
            <CardContent className={classes.cardContent}>
              {renderMetrics(
                alertsData,
                module === "IF" || module === "TM"
                  ? handleAlertMetricClick
                  : handleViewPowerBi,
                RiskDialogBox,
                module,
              )}
            </CardContent>
          </>
        )}
      </Card>
      <ViewAllAlerts
        open={viewAll}
        handleClose={handleViewAll}
        handleViewAll={handleViewAll}
      />
      <AlertGraphPopUp
        alertData={seletedAlertData}
        open={showAlertGraph}
        handleClose={handleCloseAlertGraph}
      />
    </>
  );
};

export default AlertDialogBox;
